/* eslint-disable */

import React, { useContext } from 'react';
import {
  AppBar,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
  Slide,
  useScrollTrigger,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';

// Slide hide on scroll down
function HideOnScroll({ children }) {
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export default function NavbarEDonation({
  openMobile,
  onMobileNavOpen,
  onMobileNavClose,
}) {
  const { handleSignout } = useContext(PassportAuth);
  const userName = getStorage('username');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg')); // เปลี่ยน xl -> lg เพื่อแบ่ง desktop/mob ได้จริง

  return (
    <Box sx={{ display: 'flex', marginBottom: { xs: '50px', md: '10px' } }}>
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            height: '50px',
            background: '#f5f5f5',
            boxShadow: 'none',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              color: 'black',
              height: '100%',
              alignItems: 'center', // ทำให้ไอคอนและข้อความอยู่ระดับเดียวกัน
              px: 1,
            }}
          >
            {/* ปุ่มเปิด Sidebar */}
            <IconButton
              onClick={() => {
                openMobile ? onMobileNavClose() : onMobileNavOpen();
              }}
              sx={iconButtonStyle}
            >
              <MenuIcon fontSize="small" />
            </IconButton>

            <Box flexGrow={1} />

            {/* ปุ่ม Logout */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography variant="body2" color="textSecondary">
                ออกจากระบบ
              </Typography>

              <IconButton onClick={handleSignout} sx={iconButtonStyle}>
                <MeetingRoomIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </AppBar>
      </HideOnScroll>
    </Box>
  );
}

const iconButtonStyle = {
  p: 1.2,
  borderRadius: '12px',
  backgroundColor: '#fff',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'primary.main',
    color: '#fff',
    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.25)',
  },
};
